export const MAX_EXPORT_CSV_LENGTH = 8 * 1024 * 1024;
